<template>
    <div class="container">
        <h1 class="bg-warning text-light rounded-pill">Laatste nieuws</h1>
        <h3 class="p-2 rounded-pill">Hier vindt u het recentste reguliere TOS journaal</h3>

        <div class="embed-responsive embed-responsive-16by9 mx-auto border">
            <iframe class="embed-responsive-item" src="https://www.youtube.com/embed/iwhWevoMBdU?rel=0"></iframe>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'nieuws'
    }
</script>
<style scoped>
    h3 {
        background-color: lightblue;
    }
</style>

